import { motion } from "framer-motion";
import { OPPORTUNITIES, PROFESSIONAL_TYPES } from "../lib/professionals";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";

const OpportunityGrid = () => (
    <section
        data-testid="opportunity-section"
        className="relative bg-ink py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    THE OPPORTUNITY
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    P.01 — P.06
                </p>
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="opportunity-headline"
                className="mt-12 max-w-4xl font-display text-[clamp(1.75rem,9.2vw,2.25rem)] font-semibold leading-[1.1] text-white md:text-6xl"
            >
                WHAT BUILDEASE OFFERS PROFESSIONALS
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="professional-types"
                className="mt-10 flex flex-wrap gap-2.5"
            >
                {PROFESSIONAL_TYPES.map((t) => (
                    <span
                        key={t}
                        className="border border-white/15 px-3.5 py-2 font-mono text-[13px] tracking-[0.2em] text-mist"
                    >
                        {t}
                    </span>
                ))}
            </motion.div>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3"
            >
                {OPPORTUNITIES.map((o) => (
                    <motion.div
                        key={o.n}
                        variants={fadeUp}
                        data-testid={`opportunity-${o.n
                            .toLowerCase()
                            .replace(".", "-")}`}
                        className="group border-t border-white/15 pt-6"
                    >
                        <div className="flex items-center justify-between">
                            <p className="font-mono text-[13px] tracking-[0.3em] text-accent">
                                {o.n}
                            </p>
                            <o.icon
                                className="h-4 w-4 text-cad transition-colors duration-300 group-hover:text-accent"
                                aria-hidden="true"
                            />
                        </div>
                        <h3 className="mt-5 font-display text-lg font-semibold leading-snug tracking-wide text-white">
                            {o.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-mist">
                            {o.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default OpportunityGrid;
